import { render, staticRenderFns } from "./PostText.vue?vue&type=template&id=720b0a0d&scoped=true&"
import script from "./PostText.vue?vue&type=script&lang=js&"
export * from "./PostText.vue?vue&type=script&lang=js&"
import style0 from "./PostText.vue?vue&type=style&index=0&id=720b0a0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720b0a0d",
  null
  
)

export default component.exports